// extracted by mini-css-extract-plugin
module.exports = {"plan":"inventario_campo_plan__22rsf","estatus_des":"inventario_campo_estatus_des__2RAm1"};